<template>
  <div :class="classes">
    <div v-if="title" class="simple-section--title">
      <span v-html="title"></span>
    </div>
    <div class="simple-section--content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dark: Boolean,
    light: Boolean,
    title: String,
    nopadding: Boolean,
    center: Boolean,
  },
  computed: {
    classes() {
      return {
        "simple-section": true,
        "simple-section--dark": this.dark,
        "simple-section--light": this.light,
        "simple-section--no-padding": this.nopadding,
        "simple-section--center": this.center,
      };
    },
  },
};
</script>

<style>
.simple-section {
  display: block;
}

.simple-section--title {
  font-size: 150%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.125), transparent);
  padding: 10pt 35pt;
}
.simple-section--center .simple-section--title {
  text-align: center;
}

.simple-section--content {
  padding: 20pt 20pt 35pt 35pt;
}

.simple-section--no-padding .simple-section--content {
  padding: 0pt;
}

.simple-section,
.simple-section--light {
  background: linear-gradient(-45deg, #424242, #575757);
  color: rgba(255, 255, 255, 0.8);
}

.simple-section.simple-section--dark {
  background: linear-gradient(-45deg, #252525, #3c3c3c);
  color: rgba(255, 255, 255, 0.8);
}

.simple-section.simple-section--dark .simple-section--title {
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.125), transparent);
}
</style>
